import React from "react";
import WeekdayPicker from "@/components/basic/DatePicker/WeekdayPicker";
import { useReserveForm } from "@/components/reserve/Reserve/ReserveFormProvider";
import { convertTZ } from "@/lib/utils";

export const ReserveFormWeekDaysSelect: React.FC = () => {
  const { form, weekDates, currentOfficeTz, isMeetingRoom } = useReserveForm();
  const currentOfficeDayIndex = convertTZ(new Date(), currentOfficeTz).getDay();

  const getCurrentWeek = (officeTZ: string) => {
    const officeTZDate = convertTZ(new Date(), officeTZ);
    return Array(7)
      .fill(new Date(officeTZDate))
      .map((el, idx) => new Date(el.setDate(el.getDate() - el.getDay() + idx)));
  };

  return (
    <WeekdayPicker
      form={form}
      weekDates={weekDates}
      currentWeek={getCurrentWeek(currentOfficeTz)}
      currentDayIdx={currentOfficeDayIndex}
      singleSelect={isMeetingRoom}
    />
  );
};
